<template>
  <div class="home p-5">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <!-- Kraken Home -->
    <div class="p-3 bg-transparent" style="margin-top: 65px; height: 80vh;">
      <div :class="{'temporal-disable': loading}">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <button class="bg-black p-3 w-100 circular" @click="moveRoute('suite')">
              <img :src="require(`@/assets/app/logobar.png`)" :alt="'Kraken'" width="150" height="150" class="img-fluid rounded d-inline-block align-text-center" title="Kraken - Suite">
            </button>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-3">
            <button class="bg-black p-3 w-100 circular" @click="moveRoute('alchemy')">
              <img :src="require(`@/assets/logos/alchemy_logo.png`)"  width="120" height="120" class="img-fluid rounded d-inline-block align-text-center" title="Alchemy - Monitoring, reporting and visualization of your devices.">
            </button>
          </div>
          <div class="col-md-3">
            <button class="bg-black p-3 w-100 circular" @click="moveRoute('autobackups')">
              <img :src="require(`@/assets/logos/autobackups_logo.png`)"   width="120" height="120" class="img-fluid rounded d-inline-block align-text-center" title="Autobackups - Automatic backups for your devices. | Download your backups.">
            </button>
          </div>
          <div class="col-md-3">
            <button class="bg-black p-3 w-100 circular" @click="moveRoute('fluxity')">
              <img :src="require(`@/assets/logos/fluxity_logo.png`)" width="120" height="120" class="img-fluid rounded d-inline-block align-text-center" title="Fluxity - See what is flowing in your network.">
            </button>
          </div>
          <div class="col-md-3">
            <button class="bg-black p-3 w-100 circular" @click="moveRoute('kairos')">
              <img :src="require(`@/assets/logos/kairos_logo.png`)" width="120" height="120" class="img-fluid rounded d-inline-block align-text-center" title="Kairos - Your own NTP server, your network on time.">
            </button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-1"></div>
          <div class="col-md-4">
            <button class="bg-black p-3 w-100 circular" @click="moveRoute('panoptico')" title="Panoptico - Observability of your users and groups.">
              <img :src="require(`@/assets/logos/panoptico_logo.png`)"  width="120" height="120" class="img-fluid rounded d-inline-block align-text-center" >
            </button>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-4">
            <button class="bg-black p-3 w-100 circular" @click="moveRoute('synapse')" title="Synapse - Monitoring and analysis of web services and endpoints.">
              <img :src="require(`@/assets/logos/synapse_logo.png`)"  width="120" height="120" class="img-fluid rounded d-inline-block align-text-center" >
            </button>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import HeaderBar3 from '@/components/HeaderBar3.vue'
import axios from "axios";

export default {
  name: 'Home',
  components: {
    HeaderBar3,
  },
  data(){
      return {
        //site: process.env.VUE_APP_SERVICE_URL,  // Origin
        //site: `${window.location.protocol}//${window.location.host}/kraken`,
        site: null,
        service_mode: null, // PV | PB
        stage: null,        // D  | P
        customer: null,     // Solve
        loading: false,
        // View
        view: 'home',
        hbref: 'hb_home',
        section: null,
        preferred: 'secone',
        sections: [],
        apps: {}
      }
  },
  methods: {
    // 
    //Apps
    capitalize(_string){
        const lower = _string.toLowerCase()
        return _string.charAt(0).toUpperCase() + lower.slice(1)
    },
    moveRoute(routeName){
        // Formatting
        var routeName = routeName.replace('_','-')
        // Protection.
        const cr = String(this.$route.path).replace("/","")
        if (cr != routeName){
            this.loading = true
            this.$router.push(routeName)
        }
    },
    testing(mode){
      alert(mode)
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
      return err_message
    },
    // Retrieve the username, client and sections from the current view.
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }

  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
    // Set current view.

    //localStorage.setItem('kraken_view','Home')
    // Use DNS

    //this.appclient = localStorage.getItem('vrfaware_client')
    //try {
    //  this.appSections = localStorage.getItem('vrfaware_app_sections').split(",")
    //  this.setAppSection(this.appSections[0])
    //} catch (error) {
    //  this.appSections = []
    //  this.appSection = null
    //}
  },
  mounted: function(){
    //this.solve()
  }
}
</script>

<style scoped>

  .circular{
    border: solid 2px rgb(0, 0, 0);
    border-radius: 50%;
    transition-duration: 1s;
  }
  .circular:hover{
    border: solid 2px rgb(30, 87, 162);
  }

  .gradient-text{
      background-image: linear-gradient(rgb(57, 198, 249), rgb(0, 34, 90));
      color: transparent;
      background-clip: text;
  }
  .gradient-text:hover{
      background-image: linear-gradient(rgb(0, 34, 90), rgb(57,198,249));
      color: transparent;
      background-clip: text;
  }

  .temporal-disable{
    pointer-events: none;
    opacity: 0.5;
  }

</style>